type RefreshHandler = () => Promise<boolean>

let refreshHandler: RefreshHandler | null = null

export function setAuthRefreshHandler(handler: RefreshHandler | null): void {
  refreshHandler = handler
}

export function getAuthRefreshHandler(): RefreshHandler | null {
  return refreshHandler
}
